import React, { useState, useContext } from "react";

import { makeStyles } from "@material-ui/core/styles";
import { Grid, Button, Tooltip } from "@material-ui/core";

import PaypalFunctionsModal from "./PaypalFunctionsModal";

import DisputeContext from "../../../../context/paypal/disputes/DisputeContext";

const PaypalFunctionsHome = ({
  linkProvideSupportInfo,
  linkAcceptClaim,
  linkAppeal,
  linkProvideEvidence,
  linkEscalate,
  linkMakeOffer,
  linkAcknowledge,
  dispute,
  order,
  setReturnedMsg,
}) => {
  const disputeContext = useContext(DisputeContext);
  const { loading } = disputeContext;

  const [modalOpen, setModalOpen] = useState(false);
  const [selectedFunction, setSelectedFunction] = useState();

  const useStyles = makeStyles((theme) => ({
    cardFooterDetails: {
      height: 100,
      padding: theme.spacing(2),
    },
    buttonFunction: {
      fontSize: 11,
      borderRadius: 15,
      "&:focus": {
        outline: "none",
      },
    },
  }));

  const onProvideSupportInfoClick = () => {
    setModalOpen(true);
    setSelectedFunction("provide_supporting_info");
  };
  const onAcceptClaimClick = () => {
    setModalOpen(true);
    setSelectedFunction("accept_claim");
  };
  const onAppealClick = () => {
    setModalOpen(true);
    setSelectedFunction("appeal");
  };
  const onProvideEvidenceClick = () => {
    setModalOpen(true);
    setSelectedFunction("provide_evidence");
  };
  const onEscalateClick = () => {
    setModalOpen(true);
    setSelectedFunction("escalate");
  };
  const onMakeOfferClick = () => {
    setModalOpen(true);
    setSelectedFunction("make_offer");
  };
  const onAcknowledgeClick = () => {
    setModalOpen(true);
    setSelectedFunction("acknowledge_return_item");
  };

  const classes = useStyles();

  return (
    <Grid
      container
      direction="row"
      justifyContent="flex-start"
      alignItems="center"
      spacing={1}
      className={classes.cardFooterDetails}
    >
      {linkProvideSupportInfo ? (
        <Grid item>
          <Tooltip title="Provides supporting information for a dispute">
            <Button
              variant="outlined"
              color="primary"
              onClick={onProvideSupportInfoClick}
              disabled={loading}
              className={classes.buttonFunction}
            >
              Provide Supporting Info{" "}
            </Button>{" "}
          </Tooltip>{" "}
        </Grid>
      ) : null}{" "}
      {linkAcceptClaim ? (
        <Grid item>
          <Tooltip title="Accepts liability for a claim">
            <Button
              variant="outlined"
              color="primary"
              onClick={onAcceptClaimClick}
              disabled={loading}
              className={classes.buttonFunction}
            >
              Accept Claim{" "}
            </Button>{" "}
          </Tooltip>{" "}
        </Grid>
      ) : null}{" "}
      {/* {linkAppeal ? (
                  <Grid item>
                    <Tooltip title="Appeals a dispute">
                      <Button
                        variant="outlined"
                        color="primary"
                        onClick={onAppealClick}
                        disabled={loading}
                        className={classes.buttonFunction}
                      >
                        Appeal
                      </Button>
                    </Tooltip>
                  </Grid>
                  ) : null} */}{" "}
      {/* { linkProvideEvidence &&
                  dispute.reason === "MERCHANDISE_OR_SERVICE_NOT_RECEIVED" || dispute.reason
                  === "UNAUTHORISED" || dispute.reason === "DUPLICATE_TRANSACTION" ? (
                  <Grid item>
                    <Tooltip title="Provides evidence for a dispute">
                      <Button
                        variant="outlined"
                        color="primary"
                        onClick={onProvideEvidenceClick}
                        disabled={loading}
                        className={classes.buttonFunction}
                      >
                        Provide Evidence
                      </Button>
                    </Tooltip>
                  </Grid>
                  ) : null} */}{" "}
      {linkEscalate ? (
        <Grid item>
          <Tooltip title="Escalates the dispute to a PayPal claim">
            <Button
              variant="outlined"
              color="primary"
              onClick={onEscalateClick}
              disabled={loading}
              className={classes.buttonFunction}
            >
              Escalate{" "}
            </Button>{" "}
          </Tooltip>{" "}
        </Grid>
      ) : null}{" "}
      {linkMakeOffer ? (
        <Grid item>
          <Tooltip title="Makes an offer to the other party to resolve a dispute">
            <Button
              variant="outlined"
              color="primary"
              onClick={onMakeOfferClick}
              disabled={loading}
              className={classes.buttonFunction}
            >
              Make Offer{" "}
            </Button>{" "}
          </Tooltip>{" "}
        </Grid>
      ) : null}{" "}
      {linkAcknowledge ? (
        <Grid item>
          <Tooltip title="Acknowledges that the customer returned an item for a dispute">
            <Button
              variant="outlined"
              color="primary"
              onClick={onAcknowledgeClick}
              disabled={loading}
              className={classes.buttonFunction}
            >
              Acknowledge{" "}
            </Button>{" "}
          </Tooltip>{" "}
        </Grid>
      ) : null}{" "}
      <PaypalFunctionsModal
        modalOpen={modalOpen}
        setModalOpen={setModalOpen}
        order={order}
        selectedFunction={selectedFunction}
        setReturnedMsg={setReturnedMsg}
      />{" "}
    </Grid>
  );
};

export default PaypalFunctionsHome;
